<template >
  <v-layout column justify-center="" align-center=""
    fill-height="" class="b1" color="red lighten-5" >
        <v-spacer></v-spacer>
        <div>
          <v-img  
            class="mx-4 fa-spint"  
            width="150"
            :src="'/masoathu/logo.png'"
            />  
        </div>
        <!-- <div class="not-f7 font-weight-bold primary--text">TIDZIWE</div>
        <div class="not-f4 font-weight-bold accent--text ">Early Warning Governance System</div> -->
        <div class="mx-3 pa-2 text-center">
          <v-progress-circular 
              :indeterminate="true" 
              :height="3" 
              color="primary"/> 
        </div>
      <v-layout class="">
          <v-icon color="b1">phone</v-icon>
          <v-icon color="b1">fab fa-facebook</v-icon> 
      </v-layout>
     
  </v-layout>
</template>

<script>
let pageName = 'sp'
export default { 
  name: pageName,
  data () {
    return { 
      open:false, 
    }
  },
  computed:{ 
  },
  methods:{
   
  }, 
}
</script>
